import { heroCards } from "@/mocks/doumanData";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20flat%20illustration%20of%20a%20cozy%20comic%20reading%20desk%20with%20stacked%20colorful%20comic%20books%20and%20a%20tablet%2C%20bold%20clean%20outlines%2C%20warm%20cream%20orange%20and%20teal%20palette%2C%20soft%20geometric%20shapes%2C%20artistic%20abstract%20background%2C%20no%20text&width=1920&height=1080&seq=dm-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-16 md:pt-36 md:pb-24">
        <div className="max-w-3xl mx-auto text-center dm-fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs md:text-sm font-medium backdrop-blur">
            <i className="ri-map-pin-2-line" aria-hidden="true"></i>
            官网入口 · APP下载 · 最新地址 一站式整理
          </span>
          <h1 className="mt-6 font-heading font-black text-3xl md:text-5xl leading-tight text-background-50">
            抖漫官网入口与最新地址
            <br className="hidden md:block" />
            一站式导航，在线看漫画不迷路
          </h1>
          <p className="mt-5 text-sm md:text-base leading-relaxed text-background-100 max-w-2xl mx-auto">
            找不到网址、进不去页面、不知道从哪里下载客户端？本页汇总抖漫的多种访问途径、APP 下载方式与最新地址获取方法，
            并整理常见进入问题与使用教程，帮你快速登录并顺畅阅读。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3">
            <a
              href="#access"
              className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看访问入口
            </a>
            <a
              href="#address"
              className="px-6 py-3 rounded-md bg-background-50/10 border border-background-50/40 text-background-50 text-sm font-bold hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              获取最新地址
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {heroCards.map((card) => (
            <a
              key={card.title}
              href={card.href}
              className="group block p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${card.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="px-2 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-bold">
                  {card.tag}
                </span>
              </div>
              <h2 className="mt-4 font-heading font-bold text-base text-foreground-950">{card.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{card.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 group-hover:gap-2 transition-all">
                前往查看
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}